export const MainCorousalData = [
  {
    image: "/assets/images/banner1.jpg",
    link: "https://www.samyakk.com/blog/wp-content/uploads/2023/03/MAIN-BANNER-lehenga.jpg"
  },
  {
    image: "/assets/images/banner2.jpg",
    link: "https://ik.imagekit.io/4sjmoqtje/tr:w-1920,c-at_max/cdn/shop/files/Bridal-banner-desk-12-4-24.jpg?v=1729079055"
  },
  {
    image: "/assets/images/banner3.jpg",
    link: "https://www.samyakk.com/blog/wp-content/uploads/2023/10/Lehenga-Banner.gif"
  },
  {
    image: "/assets/images/banner4.jpg",
    link: "https://www.samyakk.com/blog/wp-content/uploads/2025/05/cropped-Best-Designer-Ethnic-Wear.jpg"
  }
];
